import { render, staticRenderFns } from "./SuggestionsMailbox.vue?vue&type=template&id=5ad9d2a2&"
import script from "./SuggestionsMailbox.vue?vue&type=script&lang=js&"
export * from "./SuggestionsMailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports